import { CoreApi, ProductType } from '@inter-ikea-storageone/range';
import { SelectedMenu } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import addToTarget from 'rangeConfig/shared/behaviors/addToTarget';
import deleteSelectedEntity from 'rangeConfig/shared/behaviors/deleteSelectedEntity';
import {
  matchDepth,
  matchDimensions,
  matchHeight,
  matchWidth
} from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import platform from 'rangeConfig/shared/utils/platform';
import DimensionsLabel from 'rangeConfig/shared/widgets/DimensionsLabel';
import replaceFrame from 'rangeConfig/jonaxel/behaviors/replaceFrame';
import { sortInteriors } from 'rangeConfig/jonaxel/sorting/sort';
import { getProductCardIconWithTooltip } from '../../utils/productCardUtils';
import { matchFrames } from 'rangeConfig/jonaxel/filters/matchInteriorsToFrames';
import {
  selectedEntityIsNotClothRail,
  selectedFrameHasShelvingCounterpart
} from 'rangeConfig/jonaxel/rules/hideMenuRules';

const SelectedMenuLabel = (coreApi: CoreApi) => {
  const selectedProduct = coreApi.entities.findSelectedEntity();

  if (selectedProduct) {
    const productType = coreApi.entities.getProductType(selectedProduct);

    switch (productType) {
      case ProductType.JONAXEL_FRAME:
        return 'storageone.selectedProductListFrame';
      case ProductType.JONAXEL_FRAME_SHELF:
        return 'storageone.selectedProductListChangeShelvingUnit';
      case ProductType.JONAXEL_CLOTH_RAIL_ADJUSTABLE:
        return 'storageone.jonaxelAdjClRailInfoSheetTitle';
    }
  }

  return 'storageone.selectedProductListCustomiseShelvingUnit';
};

const frames = {
  id: 'frame-selected-menu',
  title: 'storageone.filterOptionFrames',
  cardsSubtitle: 'typeName, communicatedSizeText',
  filters: [],
  behaviors: {
    productClicked: [replaceFrame],
    productDropped: [replaceFrame]
  },
  productTypes: [ProductType.JONAXEL_FRAME, ProductType.JONAXEL_FRAME_SHELF],
  productFilters: [matchWidth, matchHeight, matchDepth],
  productCardIcon: getProductCardIconWithTooltip,
  hidden: selectedFrameHasShelvingCounterpart
};

const inserts = {
  cardsTitle: 'name',
  id: 'section-selected-menu-interiors',
  title: 'storageone.productListInsertsAndBoxesTitle',
  cardsSubtitle: 'typeName, communicatedSizeText',
  filters: [],
  behaviors: {
    productClicked: [addToTarget],
    productDropped: [addProduct]
  },
  productTypes: [
    ProductType.JONAXEL_WIRE_BASKET,
    ProductType.JONAXEL_MESH_BASKET,
    ProductType.JONAXEL_CLOTH_RAIL_ADJUSTABLE
  ],
  productFilters: [matchWidth, matchFrames],
  cluster: ['globalItemNo'],
  sortClusteredProducts: sortInteriors,
  productCardIcon: getProductCardIconWithTooltip
};

const productCardWidget = {
  id: 'frames-selected-menu-frames',
  behaviors: {},
  noThumbs: () => true,
  productFilters: [matchDimensions],
  hidden: selectedEntityIsNotClothRail
};

const size = {
  id: 'display-size',
  title: 'storageone.sizeFilterLabel',
  component: DimensionsLabel
};

const widgets = {
  desktop: [size, frames, inserts, productCardWidget],
  mobile: [inserts, frames]
};

const selectedMenu: SelectedMenu = {
  menuTitle: SelectedMenuLabel,
  behaviors: {
    productDeleted: [deleteSelectedEntity]
  },
  content: widgets[platform]
};

export default selectedMenu;
